import { useCallback, useState } from 'react';

import S from './styles';

interface Props {
  title: string;
  showBadge: boolean;
}

export default ({ title, showBadge }: Props) => {
  const [sectionWidth, setSectionWidth] = useState<number>();

  const handleLayout = useCallback(
    event => {
      if (showBadge) {
        setSectionWidth(event.nativeEvent.layout.width);
      }
    },
    [setSectionWidth, showBadge]
  );

  const showBadgeAndSectionWidth = showBadge && sectionWidth;

  return (
    <S.TitleSection testID="section" onLayout={handleLayout}>
      <S.Title
        numberOfLines={1}
        showBadgeAndSectionWidth={showBadgeAndSectionWidth}
      >
        {title}
      </S.Title>
      {Boolean(showBadgeAndSectionWidth) && (
        <S.Badge source={require('./assets/badge_new.png')} />
      )}
    </S.TitleSection>
  );
};
